export default __webpack_public_path__ + "static/media/portfolio-135.c75b6e47.jpg";